import { useIsABTestActive } from 'hooks/useIsABTestActive';

export const useCartABTests = () => ({
  isDiscountInputVisible: !useIsABTestActive('cart.isDiscountInputHidden'),
  isDiscountPercentageVisible: useIsABTestActive(
    'cart.isDiscountPercentageVisible',
  ),
  isTrustPointsVisible: useIsABTestActive('cart.isTrustPointsVisible'),
  isInfoBulletsVisible: useIsABTestActive('cart.isInfoBulletsVisible'),
  isFreeShippingProgressVisible: useIsABTestActive(
    'cart.isFreeShippingProgressVisible',
  ),
});
